/* @flow */
import React from 'react';
import { Select as AntSelect } from 'antd';

type SelectProps = {
  showSearch: Boolean,
};

const checkValue = (input, options) => {
  const { children } = options.props;
  return children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
};

const Select = (props: SelectProps) => {
  const filterOption = props.showSearch ? checkValue : null;

  return <AntSelect filterOption={filterOption} {...props} />;
};

Select.Option = AntSelect.Option;
Select.OptGroup = AntSelect.OptGroup;

export default Select;
